import events from './events'
import groups from './groups'
import reservations from './reservations'
import ridingschool from './ridingschool'

const items = { events, groups, reservations, ridingschool }

export default (type, defaults) => items[type](defaults)
